import React from "react"
import { Fade } from "react-reveal"

const Schedule = () => {
  const data = [
    {
      time: "7:00",
      title:
        "Pre-panel interview with winners of last years producer competition",
    },
    {
      time: "7:30",
      title: "SOUND reveal",
    },
    {
      time: "7:45",
      title: " $1000 producer competition TOP10 revealed",
    },
    {
      time: "8:00",
      title: "MAIN STAGE UP2SUMIN+",
      subtitleOne: "STAGE 2 Beat Review",
      subtitleTwo: "STAGE 3 Producer Skillshare",
    },
    {
      time: "9:00",
      title: "Headlining Performance",
    },
    {
      time: "9:15 ",
      title: "$1000 producer competition winners announced",
    },
    {
      time: "9:30",
      title: "Surprise giveaway to 10 lucky attendees",
    },
  ]
  return (
    <div className="schedule-container" id="schedule">
      <div className="wrapper">
        <Fade bottom cascade>
          <h1>Schedule.</h1>
        </Fade>
        <Fade bottom cascade>
          <div className="schedule-items">
            {data.map((item, index) => (
              <div className="schedule-item" key={index}>
                <h1>{item.time}</h1>
                <div className="schedule-content">
                  <h3>{item.title}</h3>
                  <p>{item.subtitleOne}</p>
                  <p>{item.subtitleTwo}</p>
                </div>
              </div>
            ))}
          </div>
        </Fade>
      </div>
    </div>
  )
}

export default Schedule
